export default __webpack_public_path__ + "static/media/Start creating a Full Journal.7c14b7ef.mp4";